import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { LiveCode } from "../components/code";
export const _frontmatter = {
  "title": "Notices"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Notices`}</h1>
    <p>{`Examples of combining `}<inlineCode parentName="p">{`@theme-ui/components`}</inlineCode>{` to create and style `}<inlineCode parentName="p">{`Alert`}</inlineCode>{`s and `}<inlineCode parentName="p">{`Message`}</inlineCode>{`s.`}</p>
    <hr></hr>
    <h3>{`With Close`}</h3>
    <p>{`Including Theme UI component's `}<inlineCode parentName="p">{`Close`}</inlineCode>{` component at the end of the alert.`}</p>
    <LiveCode backgroundColor="soft" containerSx={`sx={{display: 'grid' }}`} mdxType="LiveCode">{`<Alert>
  This is a notice <Close ml='auto' mr={-2} />
</Alert>`}</LiveCode>
    <h3>{`Rounded with Badge`}</h3>
    <p>{`Nesting a `}<inlineCode parentName="p">{`Badge`}</inlineCode>{` inside of an `}<inlineCode parentName="p">{`Alert`}</inlineCode>{`.`}</p>
    <LiveCode backgroundColor="soft" containerSx={`sx={{display: 'grid' }}`} mdxType="LiveCode">{`<Alert sx={{ borderRadius: '3' }}>
  <Badge bg="secondary" mr={2} borderRadius="3px">New!</Badge>There's a big deal that ends soon!
</Alert>`}</LiveCode>
    <h3>{`Outline`}</h3>
    <p>{`Adjusting styles to create an outline rather than a filled in `}<inlineCode parentName="p">{`Alert`}</inlineCode>{`.`}</p>
    <LiveCode containerSx={`sx={{display: 'grid' }}`} mdxType="LiveCode">{`<Alert sx={{ border: '1px solid', borderColor: 'primary', bg: 'background', color: 'primary'}}>
  Verify your account to see additional information
</Alert>`}</LiveCode>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      